"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useCurrenciesByMarketcap = exports.currenciesByMarketcap = exports.useMarketcapTickers = exports.getMarketcapTickers = exports.sortByMarketcap = exports.sortByMarketcapV2 = exports.sortByMarketcapV1 = void 0;
var react_1 = require("react");
var cache_1 = require("../cache");
var api_1 = __importDefault(require("../countervalues/api"));
var currencies_1 = require("../currencies");
var sortByMarketcapV1 = function (currencies, tickers) {
    var list = currencies.slice(0);
    var prependList = [];
    tickers.forEach(function (ticker) {
        var item = list.find(function (c) { return !c.disableCountervalue && c.ticker === ticker; });
        if (item) {
            list.splice(list.indexOf(item), 1);
            prependList.push(item);
        }
    });
    return prependList.concat(list);
};
exports.sortByMarketcapV1 = sortByMarketcapV1;
// FIXME in future we would put it back in ledgerjs to be more "dynamic"
var currenciesAndTokenWithCountervaluesByTicker;
function lazyLoadTickerMap() {
    if (currenciesAndTokenWithCountervaluesByTicker)
        return currenciesAndTokenWithCountervaluesByTicker;
    var m = new Map();
    (0, currencies_1.listTokens)().forEach(function (t) {
        if (!t.disableCountervalue && !m.has(t.ticker)) {
            m.set(t.ticker, t);
        }
    });
    (0, currencies_1.listCryptoCurrencies)().forEach(function (c) {
        if (!c.disableCountervalue) {
            m.set(c.ticker, c);
        }
    });
    currenciesAndTokenWithCountervaluesByTicker = m;
    return m;
}
var sortByMarketcapV2 = function (currencies, tickers) {
    var m = lazyLoadTickerMap();
    var list = currencies.slice(0);
    var prependList = [];
    tickers.forEach(function (ticker) {
        var item = m.get(ticker);
        if (item) {
            var i = list.indexOf(item);
            if (i !== -1) {
                list.splice(i, 1);
                prependList.push(item);
            }
        }
    });
    return prependList.concat(list);
};
exports.sortByMarketcapV2 = sortByMarketcapV2;
exports.sortByMarketcap = exports.sortByMarketcapV2;
var marketcapTickersCache;
exports.getMarketcapTickers = (0, cache_1.makeLRUCache)(function () {
    return api_1["default"].fetchMarketcapTickers().then(function (tickers) {
        marketcapTickersCache = tickers;
        return tickers;
    });
});
// React style version of getMarketcapTickers
var useMarketcapTickers = function () {
    var _a = __read((0, react_1.useState)(marketcapTickersCache), 2), tickers = _a[0], setMarketcapTickers = _a[1];
    (0, react_1.useEffect)(function () {
        var isMounted = true;
        (0, exports.getMarketcapTickers)().then(function (data) {
            if (isMounted)
                setMarketcapTickers(data);
        });
        return function () {
            isMounted = false;
        };
    }, []);
    return tickers;
};
exports.useMarketcapTickers = useMarketcapTickers;
var currenciesByMarketcap = function (currencies) {
    return (0, exports.getMarketcapTickers)().then(function (tickers) { return (0, exports.sortByMarketcap)(currencies, tickers); }, function () { return currencies; });
};
exports.currenciesByMarketcap = currenciesByMarketcap;
// React style version of currenciesByMarketcap
var useCurrenciesByMarketcap = function (currencies) {
    var tickers = (0, exports.useMarketcapTickers)();
    return tickers ? (0, exports.sortByMarketcap)(currencies, tickers) : currencies;
};
exports.useCurrenciesByMarketcap = useCurrenciesByMarketcap;
//# sourceMappingURL=sortByMarketcap.js.map